module.exports = "/build/images/icons-public.2f74cd79.svg";